import PortableTextPlus from "@/components/portable-text-plus";
import classNames from "classnames";
import SegmentContainer from "@/components/segments/segment-container";
import googleRatings from "/public/images/google-rating.png";
import Image from "next/image";
import CarouselGoogleReview from "../carousel-google-review";
import ratingGuy from "/public/images/rating-guy.png";

export default function GoogleReviewsLayout({ segment, ...props }) {
  const showRatingMan = !segment.name.includes("Testimonial");
  return (
    <SegmentContainer
      className={classNames(props.paddingClasses, "overflow-hidden")}
      style={{ ...props.bgImageStyle, ...props.bgColorStyle }}
    >
      {showRatingMan && (
        <div className="hidden md:block absolute left-0 right-0 bottom-0 w-[45%] h-full -z-[0] translate-y-[37%] -translate-x-[10%]">
          <Image
            src={ratingGuy}
            layout="intrinsic"
            alt="rating backdrop"
            className="-translate-y-[calc((100%-443px)*0.625)]"
          />
        </div>
      )}

      <div
        className={classNames(
          props.widthClasses,
          "relative flex flex-wrap sm:flex-row",
          "gap-y-4 justify-between text-center sm:text-left"
        )}
      >
        <div
          className={classNames(
            "w-full sm:w-1/3 relative",
            !showRatingMan && "flex items-center md:mb-8"
          )}
        >
          <div className="sm:pr-[6%] space-y-8">
            <div
              className={classNames(
                "leading-snug font-semibold text-black whitespace-pre-line",
                "text-2xl xl:text-3xl"
              )}
            >
              <PortableTextPlus value={segment.heading} />
              <div className="pt-3 w-[80%] md:w-[90%] mx-auto md:mx-0">
                <Image src={googleRatings} layout="" alt="google ratings" />
              </div>
            </div>
          </div>
        </div>
        <div className={classNames("w-full sm:w-2/3")}>
          <div className="sm:pl-[6%] space-y-8">
            <CarouselGoogleReview reviews={segment.blocks} />
          </div>
        </div>
      </div>
    </SegmentContainer>
  );
}
